import { WEB_DEVICE_TYPE } from '../constants/session.constant';

/** One entry of a user's `devices` list, as the sign-in answers return it. */
export interface SignedInDevice {
    macAddress?: string;
    deviceType?: string;
    loginToken?: string;
}

/**
 * The login token for this browser: the device entry with this browser's own `macAddress` and the web device type. Taking the
 * first entry would authenticate as whichever device signed in first (review MR !1 #11: the same search was written out in
 * four sign-in screens).
 */
export const findWebLoginToken = (devices: readonly SignedInDevice[] | null | undefined, macAddress: unknown): string | undefined =>
    (devices ?? []).find(
        (device) => device?.macAddress == macAddress && String(device?.deviceType ?? '').toLowerCase() === WEB_DEVICE_TYPE,
    )?.loginToken;
